import {
  Button,
  DownOutlined,
  Dropdown,
  Flex,
  Form,
  Menu,
  Typography,
} from '@ergolabs/ui-kit';
import React from 'react';
import { Observable, of } from 'rxjs';
import styled from 'styled-components';

import { useObservable } from '../../../hooks/useObservable';
import { AssetInfo } from '../../../models/AssetInfo';
import { AssetIcon } from '../../AssetIcon/AssetIcon';
import { AssetTitle } from '../../AssetTitle/AssetTitle';

interface TokenSelectProps {
  readonly value?: AssetInfo | undefined;
  readonly onChange?: (value: AssetInfo) => void;
  readonly assets$?: Observable<AssetInfo[]>;
  readonly assetsToImport$?: Observable<AssetInfo[]>;
  readonly importedAssets$?: Observable<AssetInfo[]>;
  readonly disabled?: boolean;
  readonly readonly?: boolean;
  readonly loading?: boolean;
}

const StyledDownOutlined = styled(DownOutlined)`
  font-size: 1rem;
`;

const StyledButton = styled(Button)`
  padding: 0 calc(var(--spectrum-base-gutter) * 3);
  width: 100%;
`;

const AssetSelect: React.FC<TokenSelectProps> = ({
  value,
  onChange,
  disabled,
  readonly,
  assets$,
  loading,
}) => {
  const [assets] = useObservable(assets$ || of([]));
  const handleSelectChange = (newValue: AssetInfo): void => {
    if (value?.id !== newValue?.id && onChange) {
      onChange(newValue);
    }
  };

  const overlay = (
    <Menu style={{ padding: 8, minWidth: 122, background: '#1d1d1d' }}>
      {assets?.map((a) => (
        <Menu.Item key={a.id} onClick={() => handleSelectChange(a)}>
          <Flex align="center">
            <Flex.Item marginRight={2}>
              <AssetIcon asset={a} />
            </Flex.Item>
            <Typography.Body>{a.ticker}</Typography.Body>
          </Flex>
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <>
      {loading ? (
        <Button type="default" loading size="middle">
          Loading...
        </Button>
      ) : (
        <Dropdown
          overlay={!readonly ? overlay : <></>}
          placement="bottomRight"
          trigger={['click']}
        >
          <StyledButton
            type={value ? 'ghost' : 'primary'}
            size="middle"
            disabled={disabled}
          >
            <Flex align="center">
              <Flex.Item flex={1} align="flex-start" display="flex">
                {value ? (
                  <AssetTitle gap={2} asset={value} />
                ) : (
                  'Select a token'
                )}
              </Flex.Item>
              {!readonly && (
                <Flex.Item marginLeft={2}>
                  <StyledDownOutlined />
                </Flex.Item>
              )}
            </Flex>
          </StyledButton>
        </Dropdown>
      )}
    </>
  );
};

interface TokeSelectFormItem extends TokenSelectProps {
  name: string;
}

const AssetSelectFormItem: React.FC<TokeSelectFormItem> = ({
  name,
  ...rest
}) => {
  return (
    <Form.Item name={name}>
      {(params) => <AssetSelect {...{ ...rest, ...params }} />}
    </Form.Item>
  );
};

export { AssetSelect, AssetSelectFormItem };
